import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  Post,
  PostCategories,
  PostCategoriesState,
  PostsResponse,
} from "../../types/types";

export const getPostCategories = createAsyncThunk<PostCategories[]>(
  "postCategories/getPostCategories",
  async (_) => {
    const API_URL = process.env.REACT_APP_URL_BACKEND;
    const response = await fetch(`${API_URL}/api/v1/tags/`);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    return response.json();
  }
);

const initialState: PostCategoriesState = {
  postCategories: [] as PostCategories[],
  loading: false,
  error: null,
};

const postCategoriesSlice = createSlice({
  name: "postCategories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPostCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPostCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.postCategories = action.payload;
      })
      .addCase(getPostCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default postCategoriesSlice.reducer;
